import { render, staticRenderFns } from "./addReturn.vue?vue&type=template&id=566646ac&scoped=true&"
import script from "./addReturn.vue?vue&type=script&lang=js&"
export * from "./addReturn.vue?vue&type=script&lang=js&"
import style0 from "./addReturn.vue?vue&type=style&index=0&id=566646ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566646ac",
  null
  
)

export default component.exports